import styled from 'styled-components';

export const TitleContainer = styled.div.attrs({
  className: 'TitleContainer',
})`
  border-radius: 5px 10px 0 0;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #ffffff;
`;

export const SegmentorContainer = styled.div.attrs({
  className: 'SegmentorContainer',
})`
  display: flex;
  gap: 10px;
  flex-direction: column;
`;

export const SectionContainer = styled.div.attrs({
  className: 'SectionContainer',
})`
  background: #222;
  border-radius: 5px;
`;
